// These are persisted to DB, so don't alter existing ones without a migration

// save us typoing these permission names
export const VIEW_SETTINGS = "view-settings";
export const UPDATE_SETTINGS = "update-settings";
export const SUPERUSER = "superuser";
export const ADVANCED_CONTENT_EDITOR = "advanced-content-editor"; // people who can edit templates and go further off piste than average
export const VIEW_EARLY_ACCESS_FEATURES = "view-early-access-features"; // permission to view/use EAP features in Flow that are not available to general users

// used when UI shows available permissions
export const permissions = [
  SUPERUSER,
  VIEW_SETTINGS,
  UPDATE_SETTINGS,
  ADVANCED_CONTENT_EDITOR,
  VIEW_EARLY_ACCESS_FEATURES,
];
